import { render, staticRenderFns } from "./SyscasoftForm.vue?vue&type=template&id=c4190f60"
import script from "./SyscasoftForm.vue?vue&type=script&lang=js"
export * from "./SyscasoftForm.vue?vue&type=script&lang=js"
import style0 from "./SyscasoftForm.vue?vue&type=style&index=0&id=c4190f60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports